<template>
    <section>
      <QS-h4-title title="退车核算">
        <template slot="content">
          <el-popover  placement="right-start" width="500" trigger="hover">
            <span v-html="returnAccountingTips"></span>
            <i slot="reference" class="el-icon-info icon-info"></i>
          </el-popover>
        </template>
        <template slot="right">
          订单欠款：{{ orderDueBalance }}元
        </template>
        </QS-h4-title>
      <QSColumnBox
        separator=":"
        :label-width="180"
      >
            <div class="overtime-wrapper">
              <div class="el-column-box__title">合同截止时间: </div>
              <div class="el-column-box__content">
                <div class="takeovertime-wrapper">
                  <span>{{ takeOverTime }}</span>
                  <el-button v-show="ifShowEditBtn" type="text" @click="handleTakeOverTimeEdit">编辑</el-button>
                </div>
              </div>
            </div>
            <div class="daily-rule-wrapper" v-show="dailyRuleShow">
              <div class="el-column-box__title">月付租金未足月计算规则: </div>
              <div class="el-column-box__content">
                <div class="take-daily-rule-wrapper">
                  <span>{{ dailyRuleName }}</span>
                  <el-button type="text" @click="handleTakeOverTimeEdit" :disabled="unableChangeTime">编辑</el-button>
                </div>
              </div>
            </div>
            <PreviewSettlementDialog
              ref="previewSettlementDialog"
              :orderId="orderData.id"
              :takeOverTime="takeOverTime"
              :disabledDate="startDate"
              :dailyRule="dailyRule"
              :dailyRuleShow="dailyRuleShow"
              @takeRuleChange="ruleChangeHandle"
            />
            <div>
              <div class="el-column-box__title">是否结算应退租金: </div>
              <div class="el-column-box__content">
                <el-radio-group v-model="isSettlementRefund" @change="triggerEmit">
                  <el-radio  :label="1">是</el-radio>
                  <el-radio  :label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
      </QSColumnBox>
      <QSColumnBox
          separator=":"
          :label-width="180"
        >
          <div>
            <div class="el-column-box__title">应收租金: </div>
            <div class="el-column-box__content">
              {{ receivableAmount }}元
            </div>
          </div>
          <div>
            <div class="el-column-box__title">已收租金: </div>
              <div class="el-column-box__content">
                {{ toBeReceivedAmount }}元

              </div>
          </div>
          <div>
            <div class="el-column-box__title">应收押金: </div>
            <div class="el-column-box__content">
              {{ receivableDeposit }}元
            </div>
          </div>
          <div>
            <div class="el-column-box__title">已收押金: </div>
            <div class="el-column-box__content">{{receivedDepositText}}</div>
          </div>
      </QSColumnBox>
    </section>
</template>
<script>
import moment from 'moment'
import PreviewSettlementDialog from '@/bizComponents/PreviewSettlementDialog'
import { calculateReceivableAmount } from '@/api/domain/returnLease'

import { judgeDayWithNow } from '@/utils'
import { dailyRuleState } from '@/config/carManage.js'


export default {
  props: {
    startDate: {
      type: String,
      default: '',
    },
    performanceState: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['settleDetail', 'orderData'],
  watch: {
    settleDetail: {
      handler(val) {
        const keys = ['takeOverTime',
          'isSettlementRefund',
          'receivableAmount',
          'toBeReceivedAmount',
          'receivableDeposit',
          'transferredDeposit',
          'receivedDeposit',
          'unableChangeTime',
          'dailyRule',
        ]
        this.setData(keys)
      },
    },
  },
  data() {
    return {
      returnAccountingTips: '应收租金=车辆完成交接时间所在款项周期之前周期的应收单金额+（车辆完成交接时间-车辆完成交接时间所在款项周期的第一天）/（自定义设置-车辆完成交接时间所在款项周期的总天数或30天）*车辆完成交接时间所在款项周期的应收金额',
      takeOverTime: '', // 车辆交接完成时间
      isSettlementRefund: 1, // 是否结算应退租金
      receivableAmount: 0, // 应收租金
      toBeReceivedAmount: 0, // 已收租金
      receivableDeposit: 0, // 应收押金
      receivedDeposit: 0, // 已收押金
      transferredDeposit: 0, // 是否平移
      surplusReceivableAmount: 0,
      unableChangeTime: false, // 是否禁止修改交接时间
      dailyRule: 0, // 月付租金未足月计算规则
    }
  },
  computed: {
    // 是否显示编辑按钮 原订单已续约且原订单已截止 时去掉按钮
    ifShowEditBtn() {
      const { presentEntDate, endDate, renewalOfContract } = this.orderData
      const endD = presentEntDate || endDate
      return !(renewalOfContract === 1 && judgeDayWithNow(endD))
    },
    // 已收押金显示
    receivedDepositText() {
      // transferredDeposit是否平移 1是0否
      return this.transferredDeposit === 1 ? `${this.receivedDeposit}元（已平移：${this.receivedDeposit}元）` : `${this.receivedDeposit}元`
    },
    // 订单欠款
    orderDueBalance() {
      const { receivableAmount, toBeReceivedAmount } = this
      // 是否平移，平移则已收押金this.receivedDeposit不参与扣除
      const receivedDeposit = this.settleDetail?.transferredDeposit === 1 ? 0 : this.receivedDeposit
      const num = Number(receivableAmount) - Number(toBeReceivedAmount) - Number(receivedDeposit)
      return num > 0 ? num.toFixed(2) : '0.00'
    },
    pickerOptions() {
      const { startDate } = this
      return {
        disabledDate(date) {
          // 服务端返回的开始时间之前不能选择
          return date.getTime() < new Date(startDate || '').getTime() - 8.64e7 || date.getTime() > Date.now()
        },
      }
    },
    dailyRuleShow() {
      // 未足期日租金计算规则显示条件：车辆交接完成时间不显示(待履约订单退车) && 退车核算-订单待核算及以后订单 && 租金付款方式为：月付（整月）-4 /月付（自然月）-5
      return this.performanceState && this.orderData.state >= 4500 && (Number(this.orderData.payMode) === 4 || Number(this.orderData.payMode) === 5)
    },
    dailyRuleName() {
      return dailyRuleState[this.dailyRule]
    },
  },
  methods: {
    ruleChangeHandle(val) {
      this.takeOverTime = val.newTakeOverTime ? moment(val.newTakeOverTime).format('YYYY-MM-DD HH:mm:ss') : ''
      this.dailyRule = val.dailyRule
      this.calculateReceivableAmount()
    },
    // 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
    async calculateReceivableAmount() {
      console.log(this.orderData)
      const { code, data } = await calculateReceivableAmount({
        orderId: this.orderData.id,
        takeOverTime: this.takeOverTime,
        dailyRule: this.dailyRule, // 未足期日租金计算规则
        // originTakeOverTime: this.settleDetail.takeOverTime // 原交接完成时间

      })
      if (code !== 1) return
      // 剩余租期租金:surplusReceivableAmount
      this.surplusReceivableAmount = data && data.surplusReceivableAmount || 0
      // 应收租金:receivableAmount
      this.receivableAmount = data && data.receivableAmount
      this.$emit('moneyChange', this.getData())
    },
    triggerEmit() {
      this.$emit('moneyChange', this.getData())
    },
    setData(keys) {
      keys.forEach((key) => {
        this[key] = this.settleDetail[key]
      })
      // 原订单已续约且原订单已截止时去掉按钮并且时间不可编辑
      if (!this.ifShowEditBtn) {
        const { presentEntDate, endDate } = this.orderData
        const endD = presentEntDate || endDate
        this.takeOverTime = moment(endD).format('YYYY-MM-DD 23:59:59')
      }
    },
    getData() {
      const {
        takeOverTime,
        dailyRule,
        isSettlementRefund,
        receivableAmount,
        toBeReceivedAmount,
        receivableDeposit,
        receivedDeposit,
        surplusReceivableAmount,
      } = this
      return {
        takeOverTime,
        dailyRule,
        isSettlementRefund,
        receivableAmount,
        toBeReceivedAmount,
        receivableDeposit,
        receivedDeposit,
        surplusReceivableAmount,
      }
    },
    handleTakeOverTimeEdit() {
      this.$refs.previewSettlementDialog.open()
    },
  },
  components: {
    PreviewSettlementDialog,
  },
}
</script>
  <style lang="scss" scoped>
</style>

